var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("preloader", { attrs: { display: _vm.loading, size: "small" } }),
      _vm._v(" "),
      _c("el-checkbox", {
        class: "mt-2",
        on: {
          change: function($event) {
            return _vm.updateSelected()
          }
        },
        model: {
          value: _vm.checkboxValue,
          callback: function($$v) {
            _vm.checkboxValue = $$v
          },
          expression: "checkboxValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }